import React from 'react';
import { useSelector } from 'react-redux';
import { documentoMaskView } from 'utils/masks';
import { removeTodasMascaras } from 'utils/stringFormatter';
import { pesquisarProtocolo } from 'routes/paths';
import { reloadVlibras } from 'utils/acessibilidade';
import * as S from './styles';

export const SucessoRequerimento = () => {
  const modalState = useSelector(state => state.app.modal);

  const dadosInputs = modalState?.props?.respostaApi?.formularioPessoa?.pessoa;

  const ocultarCpf = documento => {
    if (!documento) return documento;

    const documentoSemMascara = removeTodasMascaras(documentoMaskView(documento?.toString()));

    if (documentoSemMascara?.length === 11) {
      const primeiraParte = documentoSemMascara.slice(3, 6);
      const segundaParte = documentoSemMascara.slice(6, 9);
      return `***.${primeiraParte}.${segundaParte}-**`;
    }
    if (documentoSemMascara?.length === 14) {
      const primeiraParte = documentoSemMascara.slice(2, 5);
      const segundaParte = documentoSemMascara.slice(5, 8);
      return `**.${primeiraParte}.${segundaParte}/****-**`;
    }

    return documento;
  };

  React.useEffect(() => {
    reloadVlibras();
  }, [modalState]);

  return (
    <div>
      <S.Label>
        Formulário enviado com sucesso!
        <br />
        <br />
        Seu formulário está na fila de atendimento da SEFAZ, em breve um dos nossos atendentes deve iniciar o
        atendimento do requerimento.
        <br />
        <br />O protocolo da solicitação, de número <b>{modalState?.props?.respostaApi?.localizador}</b>, foi enviado
        para o E-mail <b>{dadosInputs?.email || ''}</b>. Para acompanhar o requerimento{' '}
        <a href={pesquisarProtocolo}>clique aqui</a> e informe o CPF cadastrado{' '}
        {ocultarCpf(dadosInputs?.cpf || dadosInputs?.cnpj)} e o número do protocolo.
        <br />
        Verifique também o lixo eletrônico ou a caixa de span.
        <br />
        <br />
        Caso o requerimento tenha alguma pendência, o mesmo pode ser retornado para correção, nesse caso será enviado um
        email para {dadosInputs?.email || ''}, sendo possível verificar também no detalhamento do requerimento,{' '}
        <a href={pesquisarProtocolo}>clicando aqui</a>, e o contribuinte tem um prazo de até 20 dias para realizar essa
        correção, ou o requerimento será cancelado automaticamente.
      </S.Label>
    </div>
  );
};

export default SucessoRequerimento;
